<template>
    <div class="container-summarycard">
        <div class="hearder-summarycard">
            <h4 class="title-summarycard"><i class="pl-3 fas fa-clipboard-list"></i> RESUMO</h4>
        </div>
        <div class="data-summarycard mt-4 ml-3">
          <div class="field-summary">
              <div class="field-label">Status</div>
              <div class="status-content" :style='statusColor'>{{statusText}}</div>
          </div>

          <div class="field-summary">
              <div class="field-label">Corretor</div>
              <div class="field-content">{{userData.nome}}</div>
          </div>

          <div class="field-summary">
              <div class="field-label">Data de Cadastro</div>
              <div class="field-content">{{userData.dataAcaoFormatada}}</div>
          </div>

          <div class="field-summary" v-if="showCreci">
              <div class="field-label">Creci</div>
              <div class="field-content">{{userData.creci}}</div>
          </div>

          <div class="field-summary" v-if="showCreci">
              <div class="field-label">Estado Creci</div>
              <div class="field-content">{{userData.ufCreci == null ? 'N/D' : userData.ufCreci.sigla}}</div>
          </div>

          <div class="field-summary" v-if="showEnterprises">
              <div class="field-label">Empreendimentos</div>
              <div class="field-content" v-for="entreprise in entreprisesUserArray" :key="entreprise.id">{{entreprise.nomeEmpreendimento}}</div>
          </div>

          <div class="field-summary" v-if="showEnterprises">
              <div class="field-label">Torre - Apartamento</div>
              <div class="field-content" v-for="entreprise in entreprisesUserArray" :key="entreprise.id">{{entreprise.torre}} - {{entreprise.apartamento}}</div>

          </div>

          <div class="field-summary">
              <div class="field-label">CPF</div>
              <div class="field-content">{{userData.cpf}}</div>
          </div>

          <div class="margem field-summary">
              <div class="field-label">RG</div>
              <div class="field-content">{{userData.rg}}</div>
          </div>

        </div>
    </div>
</template>
<script>
import UserSummaryCard from '@/views/private/realestate/users/components/UserSummaryCard/UserSummaryCard.js'
export default UserSummaryCard
</script>

<style scoped>

.container-summarycard{
  width: 100%;
  border: 1px solid rgb(202, 202, 202);
  background-color: white;
  border-radius: 5px;
  height: 100%;
}
.margem {
  margin-bottom: 2rem;
}
.hearder-summarycard{
  height: 50px;
  width: 100%;
  font-size: 20px;
  background-color: #008148;
  color: white;
}

.title-summarycard{
  height: 50px;
  width: 100%;
  font-size: 20px;
  background-color: #008148;
  padding-top: 15px;
  color: white;
}

.data-summarycard{
  margin-left: 0.5vw;
  display: flex;
  flex-direction: column;
  gap: 15px
}

.user-name{
  display: flex;
  font-size: 16px;
  font-weight: bold;
  color: #4F4C4D;
  justify-content: center;
  margin-bottom: 20px;
}

.Pessoa{
  font-size:18px;
  text-align: center;
}

.field-label{
  font: normal normal normal 16px/21px Segoe UI;
  color: #666666;
  margin-bottom: 5px;
  text-align: left;
  font-weight: bold;
}

.field-content{
  font-size: 15px;
  color: #2A2A2A;
}

.field-summary:last-child{
  display: flex;
  gap: 0.3rem;
  flex-direction: column;
}

.status-content{
  /* background-color: #30a75f; */
  width: fit-content;
  color: white;
  border-radius: 16px;
  padding: 5px 20px;

  display:table; /* keep the background color wrapped tight */
  padding:5px;
  padding-left: 20px;
  padding-right: 20px;
  font-size:15px;

}

.line-box{
  display: flex;
  justify-content: center;
}

.line{
  width: 400px;
  height: 1px;
  background-color: #e5e5e5;
}

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/users/components/UserSummaryCard/UserSummaryCard.vue